import { Timestamp } from '@angular/fire/firestore';
import { ConversationChannel } from '@vendasta/conversation';

export const PAGE_SIZE = 20;
export const FIRESTORE_MESSAGE_LIMIT = 20;
export const FIRESTORE_CONVERSATION_LIMIT = 20;
export const INBOX = 'Inbox';
// The zero value of the any timestamp field in Firestore. Used, amongst other things, to denote that an object is not deleted.
export const FIRESTORE_ZERO_TIMESTAMP = new Timestamp(10800, 0);
// List of United States territories that are excluded from SMS feature
// [Armed Forces Americas, Armed Forces Europe, Armed Forces Pacific, American Samoa, Micronesia, Guam, Marshall Islands, Northern Mariana Islands, Puerto Rico, Palau, U.S. Virgin Islands]
export const MARKETING_SERVICES_PIDS = ['VMKS', 'VMKA', 'VMKW', 'VMKV'];
export const SUPPORT_PID = 'VMF';

export const MAX_FILES = 1;
export const MAX_ATTACHMENT_FILES = 5;
export const MAX_RECORDING_TIME = 150_000;
export const MAX_RECORDING_SIZE_BYTES = 3.5 * 1024 * 1024;
export const AUDIO_RECORDER_MIME_CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
  'audio/ogg',
];

export const POSTHOG_CHANNEL_NAME = {
  [ConversationChannel.CONVERSATION_CHANNEL_UNDEFINED]: 'undefined',
  [ConversationChannel.CONVERSATION_CHANNEL_INTERNAL]: 'platform',
  [ConversationChannel.CONVERSATION_CHANNEL_SMS]: 'sms',
  [ConversationChannel.CONVERSATION_CHANNEL_FACEBOOK]: 'facebook',
  [ConversationChannel.CONVERSATION_CHANNEL_GOOGLE_MESSAGES]: 'google_messages',
  [ConversationChannel.CONVERSATION_CHANNEL_OPENAI]: 'openai',
  [ConversationChannel.CONVERSATION_CHANNEL_EMAIL]: 'email',
  [ConversationChannel.CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS]: 'google_business_communications',
  [ConversationChannel.CONVERSATION_CHANNEL_WEB_CHAT]: 'webchat',
  [ConversationChannel.CONVERSATION_CHANNEL_INSTAGRAM]: 'instagram',
  [ConversationChannel.CONVERSATION_CHANNEL_WHATSAPP]: 'whatsapp',
  [ConversationChannel.CONVERSATION_CHANNEL_AI_ASSISTANT]: 'ai_assistant',
  [ConversationChannel.CONVERSATION_CHANNEL_GOOGLE_CHAT]: 'google_chat',
  [ConversationChannel.CONVERSATION_CHANNEL_PERSONAL_EMAIL]: 'personal_email',
  [ConversationChannel.CONVERSATION_CHANNEL_SYSTEM]: 'system',
} as const satisfies Record<ConversationChannel, string>; // a type error here likely indicates we are missing a channel in the POSTHOG_CHANNEL_NAME object.

export const BOOKING_AVAILABILITY_KEY = 'bookingAvailability/v1';
export const BOOKING_PREFERRED_KEY = 'preferredScheduleId/v1';

export const TOOL_CALL_ACTION_KEY = 'toolCall';
export const TRANSFER_TO_AGENT_METADATA_KEY = 'transferToAgent';
export const SUPPORT_WEBCHAT_METADATA_KEY = 'supportWebchat';

export const ESCALATE_TO_SUPPORT_ACTION_KEY = 'openSupportChat';
